// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"8a022f01","186":"bf600cec","453":"e1af1b6e","531":"e78ab4e1","625":"72641edd","649":"574700ac","652":"c37f9ada","674":"46d2e70c","900":"0563cc60"}[chunkId] + ".chunk.js";
};